/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { HeoItemId } from './HeoItemId';
import {
    HeoItemIdFromJSON,
    HeoItemIdFromJSONTyped,
    HeoItemIdToJSON,
    HeoItemIdToJSONTyped,
} from './HeoItemId';
import type { HeoCustomerOrderNumber } from './HeoCustomerOrderNumber';
import {
    HeoCustomerOrderNumberFromJSON,
    HeoCustomerOrderNumberFromJSONTyped,
    HeoCustomerOrderNumberToJSON,
    HeoCustomerOrderNumberToJSONTyped,
} from './HeoCustomerOrderNumber';

/**
 * 
 * @export
 * @interface SalesOrderItemSummary
 */
export interface SalesOrderItemSummary {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemSummary
     */
    id: string;
    /**
     * 
     * @type {HeoItemId}
     * @memberof SalesOrderItemSummary
     */
    heoItemId: HeoItemId;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemSummary
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemSummary
     */
    pricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemSummary
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemSummary
     */
    discount: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemSummary
     */
    customerItemReference: string;
    /**
     * 
     * @type {Date}
     * @memberof SalesOrderItemSummary
     */
    availability?: Date;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemSummary
     */
    productNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof SalesOrderItemSummary
     */
    salesOrderCreatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemSummary
     */
    salesOrderCustomerReference: string;
    /**
     * 
     * @type {HeoCustomerOrderNumber}
     * @memberof SalesOrderItemSummary
     */
    customerOrderNumber?: HeoCustomerOrderNumber;
    /**
     * 
     * @type {OrderOrigin}
     * @memberof SalesOrderItemSummary
     */
    orderOrigin?: OrderOrigin;
    /**
     * 
     * @type {OrderType}
     * @memberof SalesOrderItemSummary
     */
    orderType?: OrderType;
}



/**
 * Check if a given object implements the SalesOrderItemSummary interface.
 */
export function instanceOfSalesOrderItemSummary(value: object): value is SalesOrderItemSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('heoItemId' in value) || value['heoItemId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('pricePerUnit' in value) || value['pricePerUnit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('customerItemReference' in value) || value['customerItemReference'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('salesOrderCreatedAt' in value) || value['salesOrderCreatedAt'] === undefined) return false;
    if (!('salesOrderCustomerReference' in value) || value['salesOrderCustomerReference'] === undefined) return false;
    return true;
}

export function SalesOrderItemSummaryFromJSON(json: any): SalesOrderItemSummary {
    return SalesOrderItemSummaryFromJSONTyped(json, false);
}

export function SalesOrderItemSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOrderItemSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'heoItemId': HeoItemIdFromJSON(json['heoItemId']),
        'quantity': json['quantity'],
        'pricePerUnit': json['pricePerUnit'],
        'total': json['total'],
        'discount': json['discount'],
        'customerItemReference': json['customerItemReference'],
        'availability': json['availability'] == null ? undefined : (new Date(json['availability'])),
        'productNumber': json['productNumber'],
        'salesOrderCreatedAt': (new Date(json['salesOrderCreatedAt'])),
        'salesOrderCustomerReference': json['salesOrderCustomerReference'],
        'customerOrderNumber': json['customerOrderNumber'] == null ? undefined : HeoCustomerOrderNumberFromJSON(json['customerOrderNumber']),
        'orderOrigin': json['orderOrigin'] == null ? undefined : OrderOriginFromJSON(json['orderOrigin']),
        'orderType': json['orderType'] == null ? undefined : OrderTypeFromJSON(json['orderType']),
    };
}

export function SalesOrderItemSummaryToJSON(json: any): SalesOrderItemSummary {
    return SalesOrderItemSummaryToJSONTyped(json, false);
}

export function SalesOrderItemSummaryToJSONTyped(value?: SalesOrderItemSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'heoItemId': HeoItemIdToJSON(value['heoItemId']),
        'quantity': value['quantity'],
        'pricePerUnit': value['pricePerUnit'],
        'total': value['total'],
        'discount': value['discount'],
        'customerItemReference': value['customerItemReference'],
        'availability': value['availability'] == null ? value['availability'] : value['availability'].toISOString(),
        'productNumber': value['productNumber'],
        'salesOrderCreatedAt': value['salesOrderCreatedAt'].toISOString(),
        'salesOrderCustomerReference': value['salesOrderCustomerReference'],
        'customerOrderNumber': HeoCustomerOrderNumberToJSON(value['customerOrderNumber']),
        'orderOrigin': OrderOriginToJSON(value['orderOrigin']),
        'orderType': OrderTypeToJSON(value['orderType']),
    };
}

